import { Row,Space , Divider, Typography,message,Card,Table,Select} from "antd"
import { useCallback, useEffect, useState,useMemo } from "react"
import linesServices from "./../../../services/LineService"
import lineProjectService from "./../../../services/LineProjectService"
import "./CenterListProjects.css"
import { useHistory ,useLocation} from "react-router-dom";
import { useParams,Link } from "react-router-dom";
import {SolutionOutlined} from "@ant-design/icons"


const {Title,Text}=Typography
const titleTable=[
    {
        title: "Titutlo del proyecto",
        key: "title" , 
        dataIndex: "title", 
    },
    {
        title: "Codigo del proyecto",
        key: "code" , 
        dataIndex: "code", 
    },
    {
        title:"Opciones sobre usuario",
          dataIndex:"",
          key: "optionsForm",
          width: 200,
          render:(_, record) => (
            <Space size="large" align='center'>
              <Link style={{display:"flex", flexDirection:"column"}} to={"/project/viewforuser/"+record.projectId}>
                <SolutionOutlined />
                <Text>Ver Información</Text>
              </Link>
            </Space>
          ),
    },
]

export default function CenterListProyects(params) {
    const [listLines,setListLines]=useState([])
    const [selectLine,setSelectLine]=useState(null)
    const [listProjects,setListProjects]=useState([])
    const history = useHistory();
    const { search } = useLocation();
    const searchParams = useMemo(
        () => new URLSearchParams(search),[search]
      );
      const {id:CenterID}=useParams()

    const getListLines=useCallback((centerId)=>{
        linesServices.getAllLinesByCenter(centerId).then((res)=>{
            const {response,success}=res.data;
           if(success){
                // console.log("response",response) 
                let ListLines=[]
                ListLines=response.map((line)=>{
                    // console.log(line)
                    return {
                        label: `${line.code} - ${line.name}`,
                        value: `${line.id}`,
                        key: `${line.id}`,
                    }
                });
                // setListLines(listLines.concat(ListLines));
                // ListLines.push({
                //     label: `!`,
                //     value: `14`,
                //     key: `14`,
                // })
                setListLines(ListLines);
                // console.success(`Se tiene ${ListLines.length} lineas`);
            }
            else{
            // message.success(`Se tiene ${ListLines.length} lineas`);
           }
        })
    },[])

    const getListProjects=useCallback((lineId)=>{
        lineProjectService.getListProjectsByLine(lineId).then((res)=>{
            const {response,success}=res.data;
            if(success){
                let ListProjectByLine=[]
                ListProjectByLine=response.map((project)=>{
                    return {
                        code: `${ project.Project.code}`,
                        title: `${ project.Project.title}`,
                        projectId: `${project.projectId}`,
                    }
                });
                // console.log(ListProjectByLine)
                setListProjects(ListProjectByLine);
                // console.success(`Se tiene ${ListProjectByLine.length} proyectos`);
            }
            else{
                message.error(`No se tiene proyectos`);
            }
        })
    },[])



    useEffect(()=>{
        getListLines(CenterID)
        if (searchParams.get('option')!=="listProjects") {
            searchParams.set('option', 'listProjects');
            history.replace({ search: searchParams.toString() });
            if(searchParams.get('line')!==null){
                setSelectLine(searchParams.get('line'))
            }
        }
    },[])

    useEffect(()=>{
        if (selectLine!=null) {
            searchParams.set('line', selectLine);
            history.replace({ search: searchParams.toString() });
        }
        getListProjects(selectLine)
    },[selectLine])

    return (<>
    <Card>
    {/* <Row style={{background:"gray", opacity: 1, borderRadius:10}}> 
            <Col span={12}>
                <Card bordered={false}>
                <Title level={4} style={{textAlign:"center"}}>Lineas</Title>
                </Card>
            </Col>
            <Col span={12}>
                <Card bordered={false}>
                <Title level={4} style={{textAlign:"center"}}>Proyectos</Title>
                </Card>
            </Col>
    </Row> */}
    <Row style={{marginBottom: 20,width:"100%"}}> 
        {/* <Col span={12}>
            <Card bordered={false}>
            <List>
                <VirtualList
                    data={listLines}
                    height={ContainerHeight}
                    itemHeight={7}
                    itemKey="id"
                    style={{marginLeft:10}} 
                >
                    {(item) => (
                    <List.Item key={item.id} onClick={()=>{getListProjects(item.id)}}>
                        <List.Item.Meta title={<a>{item.code+"-"+item.name}</a>}
                        />
                    </List.Item>
                    )}
                </VirtualList>
            </List>
            </Card>
        </Col>
        <Col span={12}>
            <Card bordered={false}>
            <List>
                <VirtualList
                    data={listProjects}
                    height={ContainerHeight}
                    itemHeight={7}
                    itemKey="id"
                    style={{marginLeft:10}}
                >
                    {(item) => (
                    <List.Item key={item?.id}>
                        <List.Item.Meta title={<a>{item?.Project?.code+"-"+item?.Project?.title}</a>}
                        />
                    </List.Item>
                    )}
                </VirtualList>
            </List>
            </Card>
        </Col> */}
        {/* <Tabs
        destroyInactiveTabPane={true}
        onChange={(e)=>{setSelectLine(e)}}
        tabPosition="top"
        items={listLines}
        ></Tabs> */}
        <Space style={{width: "inherit"}} align={"center"} direction="vertical">
            <Title level={2}>Seleccione una linea institucional</Title>
            <Select
            onChange={(value)=>{setSelectLine(value)}}
            value={selectLine}
            options={listLines}
            placeholder="Seleccione una linea del centro"
            />
        </Space>
    </Row>
    <Divider></Divider>
    <Table
    rowKey={"projectId"}
    columns={titleTable}
    dataSource={listProjects}
    >
    </Table>
    </Card>
    </>)
}
